<template>
  <div class="position-absolute card rounded measureCard p-2">
    <p><strong>Distance:</strong> {{ distance }}</p>
    <p><strong>Elevation Gain:</strong> {{ elevationGain }}</p>
    <p class="m-0"><strong>Hike Time:</strong> {{ hikeTime }}</p>
  </div>
</template>

<script>

import { defineComponent } from 'vue';
import {mapGetters} from "vuex";

export default defineComponent({
  computed: mapGetters({
    distance: 'trailOverviewMap/measuredGeoJsonDistance',
    elevationGain: 'trailOverviewMap/measuredGeoJsonElevationGain',
    hikeTime: 'trailOverviewMap/measuredGeoJsonHikeTime',
  }),
});
</script>

<style scoped>

.measureCard {
  background-color: #202020;
  top: 80px;
  right: 2%;
  border-radius: 4px;
  z-index: 1000;
}

</style>
